var map = {
	"./colleague.svg": "b227",
	"./copy.svg": "ad77",
	"./default_search.svg": "ce8b",
	"./delete.svg": "8078",
	"./edit.svg": "6e51",
	"./info.svg": "0ab7",
	"./packages.svg": "5fb3",
	"./priv.svg": "df52"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7ede";